(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminCommonPages', {
                    requireLogin: true,
                    url: 'admin/commonPages',
                    templateUrl: 'app/admin/commonPages/commonPages.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'commonPages']
                    },
                    controller: 'commonPagesCtrl'
                })
        }]);
})();